'use strict';

function allTasksDone ($marketingChecklist) {
  var allDone = false;
  var $list = $marketingChecklist.find('.marketing-checklist-list');
  var $taskContainer = $marketingChecklist.find('.task-container');

  if ($list.hasClass('show-todo')) {
    if ($taskContainer.not('.checked').length < 1) {
      allDone = true;
    }
  }

  $marketingChecklist
    .find('.marketing-checklist-list, .show-links-custom')
    .toggleClass('hidden', allDone);

  $marketingChecklist
    .find('.marketing-checklist-list-alldone')
    .toggleClass('hidden', !allDone);
}

module.exports = allTasksDone;
